import { Box, Stack } from "@mui/joy";
import { forwardRef } from "react";
import { useRecoilValue } from "recoil";
import { layoutAtom } from "recoil/layoutAtom";
import { theme } from "styles/theme";

interface FloatingAreaProps {
  fullWidth: boolean;
  children: React.ReactNode;
  noDivider?: boolean;
  backgroundColor?: string;
  paddingBottom?: string;
}

const FloatingArea = forwardRef<HTMLDivElement, FloatingAreaProps>(
  (
    {
      children,
      noDivider,
      fullWidth,
      backgroundColor = theme.vars.palette.Background.Level1,
      paddingBottom,
    },
    ref
  ) => {
    const { isLeftSideBarOpen, taskWidth } = useRecoilValue(layoutAtom);

    return (
      <Box
        ref={ref}
        sx={{
          position: "fixed",
          zIndex: 10,
          bottom: 0,
          left: fullWidth
            ? 0
            : "var(--Sidebar-width) + var(--PC-SideTab-width)",
          width: fullWidth
            ? "100%"
            : `calc(100% - var(--Sidebar-width, 0) - var(--PC-SideTab-width, 0))`,
          pointerEvents: "none",
        }}
      >
        <Box
          sx={{
            backgroundColor: backgroundColor,
            boxShadow: noDivider ? "none" : "0px 1px 0px 0px #00000014 inset;",
            px: "20px",
            py: "12px",
            ...(paddingBottom && { pb: paddingBottom }),
            pointerEvents: "auto",
            WebkitTextSizeAdjust: "100%",
            textSizeAdjust: "100%",
          }}
        >
          <Stack
            className={` w-full ${
              taskWidth === "normal" && "max-w-[660px] mx-auto"
            }`}
            alignItems="center"
          >
            {children}
          </Stack>
        </Box>
      </Box>
    );
  }
);

export default FloatingArea;
